/* global swal angular */

import './style.less';
import { isArray, mergeWith, cloneDeep } from 'lodash';
import moment from 'moment-timezone';

export default function($q, $log, $stateParams, $state, Swal, ApiClass, ProfileClass) {
  'ngInject';
  const vm = this;
  vm.$onChanges = activate;
  vm.edit = false;

  const { company_id } = ProfileClass.profileComplete.profile;

  vm.cancel = () => {
    vm.event = angular.copy(vm.resetEvent);
    vm.edit = false;
    if (!$stateParams.eventid) $state.go('app.eventManager');
  };

  vm.validate = () => {
    const isWebinar = vm.event.delivery_method === 2 || vm.event.delivery_method === 11;
    if (isWebinar) vm.event.delivery_location = 'Webinar';

    if (typeof vm.event.delivery_location !== 'string')
      return swal('Error', 'Please finish filling out the Primary Location');
    if (!vm.event.max_participants && vm.event.max_participants !== 0)
      return swal('Error', 'Please finish filling out the Primary Location Capacity');
    if (!vm.event.form_id) return swal('Error', 'Please select an evaluation form');
    if (!vm.event.prerequisites) return swal('Error', 'Please include course prerequisites');
    if (!vm.event.objectives) return swal('Error', 'Please include course objectives');
    if (!vm.event.prep) return swal('Error', 'Please include course preparation');
    if (!vm.event.summary) return swal('Error', 'Please include course summary');
    if (!vm.event.delivery_location) return swal('Error', 'Please include Primary Location');
    if (
      !vm.event.hours ||
      !vm.event.hours.length ||
      !vm.event.hours.every(
        ({ credits, category_id }) => typeof credits !== 'undefined' && typeof category_id !== 'undefined'
      )
    )
      return swal('Error', 'Please include correct credit information');
    if (moment(vm.event.delivery_date).unix() >= moment(vm.event.delivery_end_date).unix())
      return swal('Error', 'Please update the end time to be after the start time');
    if (!vm.event.instructors || !vm.event.instructors.length)
      return swal('Error', 'Please include at least one instructor');

    if (vm.event.priceText && vm.event.priceText.length > 20)
      return swal('Error', 'Please set the price text to less than 20 characters');
    return false;
  };

  vm.buildParams = () => {
    const params = {
      access: vm.event.access,
      approval: vm.event.approval,
      courseAudience: vm.event.courseAudience,
      course_id: vm.event.course_id,
      course_name: vm.event.course_name,
      course_summary: vm.event.course_summary,
      custom_emails: vm.event.custom_emails,
      delivery_date: moment(vm.event.delivery_date).toISOString(),
      delivery_end_date: moment(vm.event.delivery_end_date).toISOString(),
      delivery_method: vm.event.delivery_method,
      delivery_location: vm.event.delivery_location,
      delivery_location_google_place_id: vm.event.delivery_location_google_place_id,
      delivery_location_lat: vm.event.delivery_location_lat,
      delivery_location_lng: vm.event.delivery_location_lng,
      delivery_location_time_zone_id: vm.event.delivery_location_time_zone_id,
      event_id: vm.event.event_id,
      form_id: vm.event.form_id,
      hours: vm.event.hours,
      hours_basic: vm.event.hours_basic,
      inviteOnly: vm.event.inviteOnly || false,
      firmOnly: vm.event.firmOnly || false,
      learningObjectives: vm.event.learningObjectives,
      level: vm.event.level,
      locations: (vm.event.locations || []).filter(({ primary }) => !primary),
      instructors: vm.event.instructors,
      notifications: vm.event.notifications,
      majorTopics: vm.event.majorTopics,
      max_participants: vm.event.max_participants || 0,
      objectives: vm.event.objectives,
      payee: vm.event.payee,
      prep: vm.event.prep,
      prerequisites: vm.event.prerequisites,
      price: vm.event.price,
      priceTerms: vm.event.priceTerms || '',
      priceType: vm.event.priceType || 'credit',
      priceText: vm.event.priceText || '',
      productImageUrl: vm.event.productImageUrl,
      sponsor: vm.event.sponsor,
      summary: vm.event.summary,
      tags: vm.event.tags,
      vendor_id: vm.event.vendor_id,
      email_update: !vm.event.suppress_email_update,
      waitlist: vm.event.waitlist || 'automatic',
      externalSessions: vm.event.externalSessions || [],
      registrationAccess: vm.event.registrationAccess || 'admin',
      blended: vm.event.blended || false
    }; //Need for an update to submit

    if (vm.event.delivery_method === 2 || vm.event.delivery_method === 11) {
      params.webinarName = vm.event.webinarName;
      params.url = vm.event.url;
      params.sessionKey = vm.event.sessionKey;
      params.webinarKey = vm.event.webinarKey;
      params.webinarId = vm.event.webinarId;
      params.webexSessionKey = vm.event.webexSessionKey;
      params.webexType = vm.event.webexType;
      params.zoomWebinarId = vm.event.zoomWebinarId;
      params.zoomMeetingId = vm.event.zoomMeetingId;
      params.zoomUserId = vm.event.zoomUserId;
      params.zoomUUID = vm.event.zoomUUID;
    }

    return params;
  };

  vm.updateEvent = () => {
    const type = !$stateParams.eventid ? 'Create' : 'Update';

    if (vm.validate()) return;

    const params = vm.buildParams();
    vm.updateSwal(params)
      .then(vm.createOrUpdateEvent)
      .then(event => {
        Swal.toast(`Event ${type}d!`, 'success');
        vm.event.event_id = event.event_id || event.eventId;
        vm.resetEvent = angular.copy(vm.event);
        const stateParams = angular.copy($stateParams);
        stateParams.eventid = vm.event.event_id;
        $state.go('app.eventManager.course.event.event-info', stateParams, { reload: true });
        vm.edit = false;
      })
      .catch(error => {
        if (error.message === 'exit') return;
        $log.error(error);
        swal('Error', error, 'error');
        throw error;
      });
  };

  vm.updateSwal = params => {
    return new Promise(resolve => {
      if (!vm.event.event_id) return resolve(params);

      if (
        vm.resetEvent.delivery_date != params.delivery_date ||
        vm.resetEvent.delivery_end_date != params.delivery_end_date
      )
        return Swal.confirm(
          'Outlook Update',
          'All Registrants will receive an updated Outlook appointment reflecting the time change.',
          'info'
        ).then(() => resolve(params));
      else if (vm.resetEvent.delivery_location != params.delivery_location)
        return Swal.confirm(
          'Outlook Update',
          'Registrants at the primary location will receive an updated Outlook appointment reflecting the location change.',
          'info'
        ).then(() => resolve(params));
      else return resolve(params);
    });
  };

  vm.createOrUpdateEvent = params => {
    if (!$stateParams.eventid) {
      return ApiClass.eventsPut({ manage: true }, { event: params }).then(({ data: { event } }) => event);
    }

    return ApiClass.eventsIdPatch({ id: $stateParams.eventid, manage: true }, { event: params }).then(
      ({ data: { event } }) => event
    );
  };

  function AttachEmailTemplates(templates) {
    if ('custom_emails' in vm.event === false) vm.event.custom_emails = {};

    templates.forEach(template => {
      if (template.id in vm.event.custom_emails) {
        return (vm.event.custom_emails[template.id] = { ...template, ...vm.event.custom_emails[template.id] });
      }

      template.active = false;
      vm.event.custom_emails[template.id] = template;
    });
  }

  function activate() {
    if (!$stateParams.eventid) {
      vm.edit = true;
      const course = vm.course;
      vm.event = {};
      vm.course = true;
      vm.event = mergeWith(course, vm.event, _arrayTrue);
      if (!vm.event.course_name) vm.event.course_name = course.name;
      vm.event.approvals = course.approval ? course.approval : false;
    }

    vm.resetEvent = cloneDeep(vm.event);

    if (vm.event) {
      ApiClass.companiesIdTypeGet(
        {
          manage: false,
          id: company_id,
          type: 'emailTemplates'
        },
        null,
        { queryParams: { 'filter:usage': 'events' } }
      )
        .then(({ data: { items: templates } }) => {
          AttachEmailTemplates(templates);
        })
        .catch(error => {
          $log.error(error);
          throw error;
        });
    }

    vm.loaded = true;
  }

  function _arrayTrue(objValue, srcValue, key) {
    if (isArray(srcValue) && !srcValue.length) {
      if (key === 'locations' || key === 'access') return srcValue;
      return objValue || [];
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/eventManager/event/info/controller.js